const presenseStatus = {
  PRESENT: 'present',
  ABSENT: 'absent'
};

const allowedProductStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED'
};

const displayOnPlanner = {
  ADDED_ON_CRM: 'added_on_crm',
  ACTIVE_CONTRACT: 'active_contract'
};

const periodType = {
  VACATION: 'VACATION',
  HOLIDAY: 'HOLIDAY'
};

export { presenseStatus, allowedProductStatus, displayOnPlanner, periodType };
